import React from 'react';
import Router from './routes/Router';

function App() {
  return (
    <div className="App">
      <Router />
      {/* Rest of your application */}
    </div>
  );
}

export default App;